import { ParamKey } from 'shared/types/QueryModel'

export const usersFilters: ParamKey[] = ['company', 'branch', 'role']
export const usersParams: ParamKey[] = [...usersFilters, 'search']
